(() => {
	angular.module('main').factory('fileUploadService', fileUploadService);

	fileUploadService.$inject = [
		'$http',
		'$q',
		'$rootScope',
		'imageConverter',
		'messageService'
	];

	function fileUploadService(
		$http,
		$q,
		$rootScope,
		imageConverter,
		messageService
	) {
		let filesList = [];

		return {
			saveFileOnServer,
			deleteFileFromServer,
			convertAttachmentsToShow,
			convertFileToSave,
			getAttachment,
			getAttachments,
			getFiles,
			setFiles,
			setAttachmentsFromServer,
			removeDuplicates
		};

		function removeDuplicates(array, keyname) {
			const output = [];
			const keys = [];

			array.forEach(item => {
				const key = item[keyname];
				if (!keys.includes(key) || !key) {
					keys.push(key);
					output.push(item);
				}
			});
			return output;
		}

		function setFiles(files, isInitLoading) {
			if (isInitLoading) {
				filesList = files;
				filesList = removeDuplicates(filesList, 'id');
			} else if (Array.isArray(files)) {
				filesList.push(...files);
				filesList = removeDuplicates(filesList, 'id');
			} else {
				filesList.push(files);
				filesList = removeDuplicates(filesList, 'id');
			}
		}

		function getFiles() {
			return filesList;
		}

		function saveFileOnServer(
			dataToSave,
			jobId,
			successCallback,
			errorCallback
		) {
			const requestedJobId = jobId;

			if (typeof requestedJobId !== 'undefined') {
				const dataToSend = new FormData();

				dataToSend.append('file', dataToSave);

				$http({
					method: 'POST',
					cache: false,
					url: `/rest/user/jobs/${requestedJobId}/attachments/`,
					data: dataToSend,
					transformRequest: angular.identity,
					headers: {
						'Content-Type': undefined,
						'Cache-Control': 'no-cache, no-store, must-revalidate'
					}
				})
					.then(result => {
						const response = result.data;
						response.convertedSize = (
							parseInt(response.bytesSize) /
							(1024 * 1024)
						).toFixed(2); // convert from bytes to MB
						const tmpDate = new Date(response.cratedTs);
						const monthNames = [
							'January',
							'February',
							'March',
							'April',
							'May',
							'June',
							'July',
							'August',
							'September',
							'October',
							'November',
							'December'
						];
						response.customLastModifiedDate = `${tmpDate.getDate()} ${
							monthNames[tmpDate.getMonth()]
						} ${tmpDate.getFullYear()}`;
						successCallback(response);
					})
					.catch(result => {
						errorCallback(result.data);
					});
			}
		}

		function deleteFileFromServer(file, jobId, successCallback, errorCallback) {
			const requestedJobId = jobId;
			const fileID = file.id;

			$http({
				method: 'DELETE',
				cache: false,
				url: `/rest/user/jobs/${requestedJobId}/attachments/${fileID}`,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			})
				.then(result => {
					const index = filesList.indexOf(file);
					filesList.splice(index, 1);
					successCallback(result.data);
				})
				.catch(result => {
					errorCallback(result.data);
				});
		}

		function getAttachment(id, jobId, successCallback) {
			const requestedId = id;
			const requestedJobId = jobId;

			$http({
				method: 'GET',
				cache: false,
				url: `/rest/user/jobs/${requestedJobId}/attachments/${requestedId}`,
				transformRequest: angular.identity,
				transformResponse: angular.identity,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			})
				.then(result => {
					successCallback(result.data);
				})
				.catch(messageService.showDefaultErrorMessage);
		}

		function getAttachments(jobId, successCallback, errorCallback) {
			const requestedJobId = jobId;

			$http({
				method: 'GET',
				url: `/rest/user/jobs/${requestedJobId}/attachments`,
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined,
					'Cache-Control': 'no-cache, no-store, must-revalidate'
				}
			})
				.then(result => {
					const response = result.data;
					angular.forEach(result, value => {
						value.convertedSize = (
							parseInt(value.bytesSize) /
							(1024 * 1024)
						).toFixed(2); // convert from bytes to MB
					});
					successCallback(response);
				})
				.catch(result => {
					errorCallback(result.data);
				});
		}

		function convertFileToBase64(file) {
			const deferred = $q.defer();
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = function() {
				if (reader.result) {
					const metaDataEnd = reader.result.indexOf(',') + 1;
					const convertedFile = reader.result.slice(metaDataEnd).trim();
					deferred.resolve({
						name: file.name,
						contentType: file.type,
						size: file.size,
						base64: convertedFile
					});
				} else {
					deferred.reject(reader.result);
				}
			};
			return deferred.promise;
		}

		function getConvertedFiles(filesArr) {
			return filesArr.map(file => convertFileToBase64(file));
		}

		function convertFileToSave(filesArr) {
			const convertedFilesPromises = getConvertedFiles(filesArr);
			const deferred = $q.defer();

			$q.all(convertedFilesPromises).then(
				result => {
					deferred.resolve(result);
				},
				error => deferred.reject(error)
			);

			return deferred.promise;
		}

		function convertAttachmentsToShow(attachments) {
			const attachmentsToShow = angular.copy(attachments);
			const monthNames = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			];

			attachmentsToShow.forEach(attachment => {
				const tmpDate = new Date(attachment.cratedTs);
				attachment.convertedSize = (
					parseInt(attachment.bytesSize) /
					(1024 * 1024)
				).toFixed(2); // convert from bytes to MB
				attachment.customLastModifiedDate = `${tmpDate.getDate()} ${
					monthNames[tmpDate.getMonth()]
				} ${tmpDate.getFullYear()}`;
				attachment.convertedType = imageConverter.getFileClass(attachment.name);
			});

			return attachmentsToShow;
		}

		function setAttachmentsFromServer(attachments) {
			let attachmentsToShow = angular.copy(attachments);
			attachmentsToShow = convertAttachmentsToShow(attachments);
			$rootScope.uploadedFiles = attachmentsToShow.length;
			setFiles(attachmentsToShow, true);
			return attachmentsToShow;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/fileUploadService.js